<script>
export default {
    props: {
        atendimento: { type: Object },
    },
    data() {
        return {
            finishData: {
                id: null,
                end_date: null,
            },
        }
    },
    computed: {
        minDate() {
            return new Date().toISOString().slice(0, 10)
        }
    },
    created() {
        // Define a data atual como padrão
        this.finishData.end_date = new Date().toISOString().slice(0, 10)
    },
    mounted() {
        if (this.atendimento) {
            this.finishData.id = this.atendimento.id
        }
    },
    watch: {
        atendimento(newValue) {
            if (newValue) {
                this.finishData.id = newValue.id
            }
        }
    },
    methods: {
        finishAtendimento() {
            this.$emit('doFinishAtendimento', {
                atendimento: {
                    id: this.finishData.id,
                    end_date: this.finishData.end_date,
                }
            })
        },
        onCancel() {
            this.$emit('onCancel')
            // Reset form
            this.finishData.end_date = new Date().toISOString().slice(0, 10)
        },
        formatDate(date) {
            if (!date) return null
            return new Date(date).toLocaleDateString('pt-BR')
        }
    }
}
</script>

<template>
    <div>
        <b-modal id="modal-finish-atendimento" :title="`Encerrar Atendimento #${finishData.id}`" size="lg"
            @hidden="onCancel"
        >
            <b-alert variant="warning" show dismissible>
                <i class="ri-alert-line"></i>
                <strong>Atenção:</strong> Esta ação não pode ser revertida. O atendimento será encerrado permanentemente.
            </b-alert>

            <!-- Dados do Atendimento -->
            <div class="card mb-3">
                <div class="card-header bg-light">
                    <h6 class="mb-0"><i class="ri-information-line"></i> Dados do Atendimento</h6>
                </div>
                <div class="card-body">
                    <div class="row mb-2">
                        <div class="col-md-6">
                            <strong>Paciente:</strong> {{ (atendimento && atendimento.pacient && atendimento.pacient.nome) || 'N/A' }}
                        </div>
                        <div class="col-md-6">
                            <strong>Profissional:</strong> {{ (atendimento && atendimento.professional && atendimento.professional.name) || 'N/A' }}
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-6">
                            <strong>Tratamento:</strong> {{ (atendimento && atendimento.treatment && atendimento.treatment.name) || (atendimento && atendimento.specialty && atendimento.specialty.name) || 'N/A' }}
                        </div>
                        <div class="col-md-6">
                            <strong>Data Início:</strong> {{ formatDate(atendimento && atendimento.start_date) || 'N/A' }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- Formulário de Encerramento -->
            <b-form @submit.prevent="finishAtendimento">
                <div class="form-group row mb-3">
                    <label class="col-md-4 col-form-label" for="end_date">
                        Data de Término <span class="text-danger">*</span>:
                    </label>
                    <div class="col-md-8">
                        <b-form-input 
                            id="end_date" 
                            v-model="finishData.end_date" 
                            type="date"
                            required
                        ></b-form-input>
                        <small class="form-text text-muted">Data em que o atendimento e todas as agendas relacionadas serão encerradas</small>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-12 text-right">
                        <b-button variant="secondary" @click="onCancel" class="mr-2">
                            <i class="ri-close-line"></i> Cancelar
                        </b-button>
                        <b-button type="submit" variant="danger">
                            <i class="ri-stop-circle-line"></i> Encerrar Atendimento
                        </b-button>
                    </div>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<style scoped>
.card {
    border: 1px solid #dee2e6;
}
.card-header {
    font-weight: 600;
}
</style>

